import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { tap, catchError, throwError, Subject, Observable, map } from 'rxjs';
import { EnvService } from '../env/env.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {

  token$ = new Subject<string>();

  constructor(
    private http: HttpClient,
    private envService: EnvService) {

  }

  refreshToken(refreshToken: string): Promise<string> {
    return new Promise((resolve, reject) => {

      const body = new URLSearchParams();
      body.set('grant_type', 'refresh_token');
      body.set('refresh_token', refreshToken);
      body.set('client_id', 'catayca');

      const options = {
        headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
      };

      const authUrl = this.envService
        .getUrlForProvider('auth')
        .featureUrl('refreshToken');

      const observer = {
        next(value: string) {
          resolve(value);
        },
        error(err: any) {
          reject(err);
        },
        complete() {
        }
      };

      this.http.post<any>(authUrl!, body.toString(), options)
        .pipe(
          map(result => result.access_token),
          tap(token => this.token$.next(token)),
          catchError(error => throwError(() => error)),
        )
        .subscribe(observer);
    });
  }


  token(): Observable<string> {
    return this.token$.asObservable();
  }
}
